(function () {
  var ROOT_SELECTOR = '.wa-playlists[data-section-id]';
  var DESKTOP_QUERY = '(min-width: 1101px) and (min-height: 650px)';
  var SPEED_RATIO = 0.88;
  var EASE = 0.105;
  var EPSILON = 0.18;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function spotifyCanonicalUrl(embedUrl) {
    if (!embedUrl) return '';
    try {
      var url = new URL(embedUrl, window.location.origin);
      if (!/open\.spotify\.com$/i.test(url.hostname)) return '';
      var path = url.pathname.replace(/^\/embed\//, '/');
      return 'https://open.spotify.com' + path;
    } catch (e) {
      return '';
    }
  }

  function loadArtwork(art) {
    if (!art || art.dataset.artworkLoaded === 'true') return;
    var canonical = spotifyCanonicalUrl(art.getAttribute('data-spotify-url'));
    if (!canonical) return;
    art.dataset.artworkLoaded = 'true';

    fetch('https://open.spotify.com/oembed?url=' + encodeURIComponent(canonical), {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Spotify artwork request failed');
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.thumbnail_url) throw new Error('No Spotify thumbnail returned');
        var img = art.querySelector('[data-playlist-auto-art]');
        if (!img) return;
        img.src = data.thumbnail_url;
        img.alt = data.title ? data.title + ' playlist artwork' : 'Playlist artwork';
        img.hidden = false;
        art.classList.remove('wa-playlist-card__art--placeholder');
        var fallback = art.querySelector('[data-playlist-art-fallback]');
        if (fallback) fallback.hidden = true;
      })
      .catch(function () {
        art.dataset.artworkLoaded = 'false';
      });
  }

  function initArtwork(scope) {
    (scope || document).querySelectorAll('[data-playlist-art][data-spotify-url]').forEach(loadArtwork);
  }

  function initModal(root) {
    var modal = root.querySelector('[data-playlist-modal]');
    if (!modal || modal.dataset.modalInit === 'true') return;
    modal.dataset.modalInit = 'true';

    var title = modal.querySelector('[data-modal-title]');
    var subtitle = modal.querySelector('[data-modal-subtitle]');
    var brand = modal.querySelector('[data-modal-brand]');
    var spotify = modal.querySelector('[data-modal-spotify]');
    var apple = modal.querySelector('[data-modal-apple]');
    var spotifyWrap = modal.querySelector('[data-modal-spotify-wrap]');
    var appleWrap = modal.querySelector('[data-modal-apple-wrap]');
    var lastTrigger = null;

    function closeModal() {
      if (modal.hidden) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('wa-playlist-modal--id');
      document.body.classList.remove('wa-playlist-modal-open');
      if (spotify) spotify.src = 'about:blank';
      if (apple) apple.src = 'about:blank';
      if (lastTrigger) lastTrigger.focus();
    }

    function openModal(trigger) {
      lastTrigger = trigger;
      var brandValue = trigger.getAttribute('data-playlist-brand') || 'whosaux';
      var spotifyUrl = trigger.getAttribute('data-spotify-url') || '';
      var appleUrl = trigger.getAttribute('data-apple-url') || '';

      if (title) title.textContent = trigger.getAttribute('data-playlist-title') || 'Playlist';
      if (subtitle) subtitle.textContent = trigger.getAttribute('data-playlist-subtitle') || '';
      if (brand) brand.textContent = brandValue === 'id' ? 'Intelligent Design' : "Who's AUX";
      modal.classList.toggle('wa-playlist-modal--id', brandValue === 'id');

      if (spotifyWrap) spotifyWrap.hidden = !spotifyUrl;
      if (appleWrap) appleWrap.hidden = !appleUrl;
      if (spotify && spotifyUrl) spotify.src = spotifyUrl;
      if (apple && appleUrl) apple.src = appleUrl;

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('wa-playlist-modal-open');
      var close = modal.querySelector('.wa-playlist-modal__close');
      if (close) close.focus();
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-playlist-open]');
      if (trigger) {
        event.preventDefault();
        openModal(trigger);
        return;
      }
      if (event.target.closest('[data-playlist-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function initHorizontal(root) {
    if (!root || root.dataset.plScrollInit === 'true') return;

    var scene = root.querySelector('[data-pl-scroll-scene]');
    var sticky = root.querySelector('[data-pl-sticky]');
    var track = root.querySelector('[data-pl-track]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pl-panel]'));
    var progressBar = root.querySelector('[data-pl-progress]');
    var count = root.querySelector('[data-pl-scroll-count]');
    if (!scene || !sticky || !track || !panels.length) return;

    root.dataset.plScrollInit = 'true';
    var desktop = window.matchMedia(DESKTOP_QUERY);
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var horizontal = false;
    var horizontalDistance = 0;
    var verticalDistance = 0;
    var sceneStart = 0;
    var currentX = 0;
    var targetX = 0;
    var animationFrame = 0;
    var resizeTimer = 0;

    function panelIndex(x) {
      var marker = x + window.innerWidth * 0.5;
      var index = 0;
      panels.forEach(function (panel, i) {
        if (marker >= panel.offsetLeft) index = i;
      });
      return clamp(index, 0, panels.length - 1);
    }

    var activePanelIndex = -1;

    function applyTheme(index) {
      var panel = panels[index];
      var light = panel && panel.getAttribute('data-header-theme') === 'light';
      var idLogo = panel && panel.getAttribute('data-header-logo') === 'id';
      root.classList.toggle('wa-playlists--light', !!light);
      document.body.classList.toggle('wa-playlists-header-light', !!light);
      document.body.classList.toggle('wa-playlists-logo-id', !!idLogo);

      if (panel && index !== activePanelIndex) {
        activePanelIndex = index;
        var panelId = panel.getAttribute('id');
        if (panelId && history.replaceState) history.replaceState(null, '', '#' + panelId);
      }
    }

    function paint(x) {
      track.style.transform = 'translate3d(' + (-x) + 'px,0,0)';
      var progress = horizontalDistance > 0 ? clamp(x / horizontalDistance, 0, 1) : 0;
      if (progressBar) progressBar.style.transform = 'scaleX(' + progress + ')';
      var index = panelIndex(x);
      if (count) count.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(panels.length).padStart(2, '0');
      applyTheme(index);
    }

    function animate() {
      animationFrame = 0;
      if (!horizontal) return;
      var delta = targetX - currentX;
      if (Math.abs(delta) <= EPSILON) {
        currentX = targetX;
        paint(currentX);
        return;
      }
      currentX += delta * EASE;
      paint(currentX);
      animationFrame = window.requestAnimationFrame(animate);
    }

    function requestAnimation() {
      if (!animationFrame) animationFrame = window.requestAnimationFrame(animate);
    }

    function syncFromScroll(immediate) {
      if (!horizontal || verticalDistance <= 0 || document.body.classList.contains('wa-playlist-modal-open')) return;
      var progress = clamp((window.scrollY - sceneStart) / verticalDistance, 0, 1);
      targetX = progress * horizontalDistance;
      if (immediate) {
        currentX = targetX;
        paint(currentX);
      } else {
        requestAnimation();
      }
    }

    function clearHorizontal() {
      horizontal = false;
      root.classList.remove('wa-playlists--horizontal', 'wa-playlists--light');
      document.body.classList.remove('wa-playlists-header-light', 'wa-playlists-logo-id');
      activePanelIndex = -1;
      root.style.removeProperty('--pl-panel-height');
      scene.style.height = '';
      track.style.transform = '';
      if (progressBar) progressBar.style.transform = '';
      if (animationFrame) window.cancelAnimationFrame(animationFrame);
      animationFrame = 0;
      currentX = 0;
      targetX = 0;
      if (count) count.textContent = '01 / ' + String(panels.length).padStart(2, '0');
    }

    function scrollToTarget(target, smooth) {
      var panel = target.closest('[data-pl-panel]') || target;
      if (!horizontal || horizontalDistance <= 0 || !panel) {
        target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
        return;
      }
      var targetXValue = clamp(panel.offsetLeft, 0, horizontalDistance);
      var progress = targetXValue / horizontalDistance;
      var top = sceneStart + progress * verticalDistance;
      window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
    }

    function layout() {
      var shouldUseHorizontal = desktop.matches && !reducedMotion.matches;
      if (!shouldUseHorizontal) {
        clearHorizontal();
        return;
      }

      horizontal = true;
      root.classList.add('wa-playlists--horizontal');
      var viewportHeight = Math.max(650, window.innerHeight);
      root.style.setProperty('--pl-panel-height', viewportHeight + 'px');
      track.style.transform = 'translate3d(0,0,0)';
      scene.style.height = viewportHeight + 'px';

      window.requestAnimationFrame(function () {
        horizontalDistance = Math.max(0, track.scrollWidth - window.innerWidth);
        verticalDistance = Math.max(viewportHeight * 0.75, horizontalDistance * SPEED_RATIO);
        scene.style.height = (viewportHeight + verticalDistance) + 'px';
        sceneStart = scene.getBoundingClientRect().top + window.scrollY;

        var hashTarget = null;
        if (window.location.hash) {
          try { hashTarget = root.querySelector(window.location.hash); } catch (e) { hashTarget = null; }
        }
        if (hashTarget && hashTarget.matches('[data-pl-panel]')) {
          var targetXValue = clamp(hashTarget.offsetLeft, 0, horizontalDistance);
          var progress = horizontalDistance > 0 ? targetXValue / horizontalDistance : 0;
          var top = sceneStart + progress * verticalDistance;
          window.scrollTo({ top: top, behavior: 'auto' });
        }
        syncFromScroll(true);
      });
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var hash = link.getAttribute('href');
      if (!hash || hash === '#') return;
      var target;
      try { target = root.querySelector(hash); } catch (e) { return; }
      if (!target) return;
      event.preventDefault();
      if (history.replaceState) history.replaceState(null, '', hash);
      scrollToTarget(target, true);
    });

    window.addEventListener('scroll', function () { syncFromScroll(false); }, { passive: true });
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(layout, 140);
    }, { passive: true });
    if (desktop.addEventListener) desktop.addEventListener('change', layout);
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', layout);

    layout();
  }

  function initVerticalIdentity(root) {
    if (!root || root.dataset.plIdentityInit === 'true' || !('IntersectionObserver' in window)) return;
    root.dataset.plIdentityInit = 'true';
    var desktop = window.matchMedia(DESKTOP_QUERY);
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pl-panel]'));
    var observer = new IntersectionObserver(function (entries) {
      if (desktop.matches) return;
      var visible = entries.filter(function (entry) { return entry.isIntersecting; })
        .sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; });
      if (!visible.length) return;
      var panel = visible[0].target;
      var light = panel.getAttribute('data-header-theme') === 'light';
      var idLogo = panel.getAttribute('data-header-logo') === 'id';
      document.body.classList.toggle('wa-playlists-header-light', light);
      document.body.classList.toggle('wa-playlists-logo-id', idLogo);
      var panelId = panel.getAttribute('id');
      if (panelId && history.replaceState) history.replaceState(null, '', '#' + panelId);
    }, { threshold: [0.25, 0.5, 0.75] });
    panels.forEach(function (panel) { observer.observe(panel); });
  }

  function initAll(scope) {
    var base = scope || document;
    base.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      initArtwork(root);
      initModal(root);
      initHorizontal(root);
      initVerticalIdentity(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
